import React, { useState } from 'react';
import { Button, Col, Row, Skeleton } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';

import { Item, Label } from '../styles';
import { Text } from '@/components/Typography';
import { useRosaContext } from '../../../context';
import { DeleteModal } from '../../../components/DeleteModal';
import { useDeleteEquipment } from '../../../hooks/useDeleteEquipment';
import { type OtherElement, useGetRequiredEquipments } from '../../../hooks/useGetRequiredEquipments';

export function List() {
	const { organization_id, company_id, report_id } = useRosaContext();

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
	const [selectedElement, setSelectedElement] = useState<OtherElement>({} as OtherElement);

	const { mutateAsync: deleteEquipment } = useDeleteEquipment();
	const { data, isLoading } = useGetRequiredEquipments({ organization_id, company_id, report_id });

	function handleToggleDeleteModal(): void {
		setIsDeleteModalOpen(!isDeleteModalOpen);
	}

	function handleOpenDeleteModal(element: OtherElement) {
		setSelectedElement(element);
		handleToggleDeleteModal();
	}

	async function handleDeleteElement(): Promise<void> {
		await deleteEquipment({
			report_id,
			company_id,
			organization_id,
			equipment_id: selectedElement.id
		});
		handleToggleDeleteModal();
	}

	if (isLoading) {
		return (
			<Row>
				<Col span={20}>
					<Skeleton.Input block active size="default" style={{ borderRadius: 6 }} />
				</Col>
			</Row>
		);
	}

	return (
		<Row gutter={[0, 10]}>
			{data?.table.map((element: any) => {
				return (
					<Item key={element.id} lg={24} xl={20}>
						<Row>
							<Col className="column" lg={10} xl={9}>
								{element.name}
							</Col>
							<Col className="column" lg={6} xl={9}>
								<Row gutter={[10, 0]}>
									<Col>
										<Label>{I18n.get('Action')}:</Label>
									</Col>
									<Col>
										<Text>{element.action}</Text>
									</Col>
								</Row>
							</Col>
							<Col className="column" lg={6} xl={4}>
								<Row gutter={[10, 0]}>
									<Col>
										<Label>{I18n.get('Priority')}:</Label>
									</Col>
									<Col>
										<Text>{element.priority}</Text>
									</Col>
								</Row>
							</Col>
							<Col className="column" lg={2} xl={2}>
								<Button
									danger
									type="ghost"
									icon={<DeleteOutlined />}
									onClick={() => handleOpenDeleteModal(element)}
								/>
							</Col>
						</Row>
					</Item>
				);
			})}
			<DeleteModal
				open={isDeleteModalOpen}
				onConfirm={handleDeleteElement}
				onCancel={handleToggleDeleteModal}
				message={I18n.get('Do you really want to delete this element?')}
			/>
		</Row>
	);
}
